import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkCampaignItem } from "../redux/actions/common.actions";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";
import Header from "../components/Header.js";

function Welcome() {
  let { key } = useParams();
  const common = useSelector(state => state.common);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(checkCampaignItem(key));
  }, [key]);

  if (!common.itemResponse) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <div id="header"></div>
            <div id="wrap">
              <div id="focus">
                <h1>{t("system.loading")}</h1>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  if (common.itemResponse.result !== "OK") {
    return (
      <Translation>
        {t => (
          <div id="main">
            <div id="header"></div>
            <div id="wrap">
              <div id="focus">
                <h1>{t("welcome.incorrect_link")}</h1>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }

  return (
    <Translation>
      {t => (
        <div id="main">
          <Header />
          <div id="wrap">
            <div className="box box-padend">
              <h1>{t("system.project_name")}</h1>
              <p>{t("welcome.introduction")}</p>
              <p>
                {t("welcome.guidance_use_phone")} <br />
                <strong>{t("welcome.guidance_grant_permission_1")}</strong>{" "}
                {t("welcome.guidance_grant_permission_2")}
              </p>
              <p>{t("welcome.guidance_enable_location")}</p>
              <p>
                <Link to="/help-iphone">
                  {t("welcome.additional_iphone_link_text")}
                </Link>{" "}
                |{" "}
                <Link to="/help-android">
                  {t("welcome.additional_android_link_text")}
                </Link>
              </p>
              <br />
              <Link className="button" to={`/${key}/locate`}>
                {t("welcome.start_button")}
              </Link>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Welcome;
